import React, { useEffect, useMemo, useState } from "react"
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Select,
  DatePicker,
  Tooltip,
  Checkbox,
} from "antd"
import {
  InfoCircleOutlined,
  LoadingOutlined,
  MinusCircleOutlined,
  PlusCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons"
import ToolBarCustom from "src/components/ToolBarCustom"

import dayjs from "dayjs"
import notice from "src/components/Notice"
import SvgIcon from "src/components/SvgIcon"
import ListPrice from "./ListPrice"
import SettingPriceService from "src/services/SettingPriceService"
import SelectCarrier from "src/components/Dropdown/SelectCarrier"
import isSameOrBefore from "dayjs/plugin/isSameOrBefore"
import { debounce } from "lodash"

dayjs.extend(isSameOrBefore)

const validateNoLettersOrSpecialChars = (_, value) => {
  const regex = /^[0-9,]+$/
  if (!value || regex.test(value)) {
    return Promise.resolve()
  }
  return Promise.reject("Chỉ được nhập số!")
}
export const initialValues = {
  // full_time: [{ basic_salary: '7,000,000' }],
  // part_time: [{ basic_salary: '3,000,000' }],
}
const renderTypeSim = value => {
  if (value === "esim") return "E-SIM"
  if (value === "usim") return "Sim vật lý"
  return value || "—"
}
const renderScope = value => {
  if (value === "1") return "Local"
  if (value === "2") return "Roaming"
  return value || "—"
}

const renderSimType = value => {
  if (value === "1") return "IoT"
  if (value === "2") return "Travel"
  return value || "—"
}

export const TimeFormList = ({ form, initialValues }) => {
  console.log(initialValues, "detailPriceConfig")
  const debouncedUpdate = useMemo(
    () =>
      debounce((index, value) => {
        const raw = value.replace(/,/g, "")
        const formatted = raw.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        const updatedSettings = [...form.getFieldValue("settings")]
        updatedSettings[index] = {
          ...updatedSettings[index],
          price: formatted,
        }
        form.setFieldsValue({ settings: updatedSettings })
      }, 100),
    [form],
  )
  return (
    <Form.List name="settings">
      {fields => {
        const settings = form.getFieldValue("settings") || []

        return (
          <>
            {fields.map(({ key }) => {
              const item = settings[key] || {}
              const initial = initialValues?.[key] || {}

              const isPastOrToday = dayjs(
                form.getFieldValue("start_time"),
              ).isSameOrBefore(dayjs(), "day")
              const initialPrice = Number(
                (initial.price || "").toString().replace(/,/g, ""),
              )
              const currentPrice = Number(
                (item.price || "").toString().replace(/,/g, ""),
              )

              const isDisabled =
                isPastOrToday &&
                initialPrice !== 0 &&
                initialPrice === currentPrice

              return (
                <Row gutter={16} key={key} style={{ marginBottom: 12 }}>
                  <Col span={5}>
                    <Form.Item label="Nhà mạng">
                      <span>{item?.network?.name || "—"}</span>
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item label="Loại SIM">
                      <span>{renderTypeSim(item?.type_sim)}</span>
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item label="Local/Roaming">
                      <span>{renderScope(item?.scope)}</span>
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item label="Loại hình SIM">
                      <span>{renderSimType(item?.sim_type)}</span>
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item
                      name={[key, "price"]}
                      label="Giá"
                      rules={[
                        {
                          required: true,
                          message: "Vui lòng nhập giá",
                        },
                        { validator: validateNoLettersOrSpecialChars },
                      ]}
                    >
                      <Input
                        placeholder="Giá sim"
                        suffix="vnđ"
                        maxLength={15}
                        disabled={isDisabled}
                        onKeyPress={e => {
                          const charCode = e.which || e.keyCode
                          if (
                            charCode !== 44 && // cho phép dấu phẩy
                            (charCode < 48 || charCode > 57)
                          ) {
                            e.preventDefault()
                          }
                        }}
                        onChange={e => {
                          debouncedUpdate(key, e.target.value)
                        }}
                        // value={item.price}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              )
            })}
          </>
        )
      }}
    </Form.List>
  )
}
function SimPriceConfig(props) {
  const [type, setType] = useState("common")
  const [loading, setLoading] = useState(false)

  const [isOpen, setIsOpen] = useState(false)

  const [form] = Form.useForm()

  const onFinish = values => {
    setLoading(true)
    console.log(values, "values")

    const payload = {
      start_time: dayjs(values.start_time).format("YYYY-MM-DD"),
      note: values.note,
      settings: (values.settings || []).map(item => ({
        ID: Number(item.ID),
        price: Number(item.price),
      })),
    }

    console.log("Payload gửi đi:", payload)

    // Gửi API update giá sim
    SettingPriceService.updatePrice(payload)
      .then(res => {
        notice({
          msg: "Cập nhật giá sim thành công!",
          isSuccess: true,
        })
        form.resetFields()
        setIsOpen(false)
      })
      .catch(err => {
        notice({
          msg: "Cập nhật thất bại!",
          isSuccess: false,
        })
      })
      .finally(() => setLoading(false))
  }

  return (
    <div>
      <ToolBarCustom title={"Chính sách lương/thưởng"} status={false} />
      <div style={{ marginBottom: "10px" }}>
        <Tooltip title={"Thêm mới chính sách"}>
          <button
            onClick={() => setIsOpen(!isOpen)}
            style={{
              cursor: "pointer",
              transition: "transform 0.3s ease",
              transform: isOpen ? "rotate(45deg)" : "rotate(0)",
              border: "none",
            }}
          >
            <SvgIcon name="plus-circle" />
          </button>
        </Tooltip>

        <div
          style={{
            maxHeight: isOpen ? "100vh" : "0",
            opacity: isOpen ? 1 : 0,
            overflowY: "scroll",
            transition: "all 0.3s ease-in-out",
          }}
        >
          <style>
            {`
            /* Ẩn thanh cuộn dọc */
            div::-webkit-scrollbar {
                width: 0;
                height: 0;
            }
            div {
                scrollbar-width: none; /* Firefox */
                -ms-overflow-style: none;  /* Internet Explorer 10+ */
            }
        `}
          </style>
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            initialValues={initialValues}
          >
            <Row gutter={[16, 16]}>
              <Col span={4}>
                <Form.Item
                  name="start_time"
                  label="Ngày áp dụng"
                  rules={[
                    {
                      required: true,
                      message: "Không được để trống!",
                    },
                  ]}
                >
                  <DatePicker
                    disabledDate={current =>
                      current && current < dayjs().startOf("day")
                    }
                    style={{ height: "37px" }}
                    format="DD/MM/YYYY"
                    placeholder="Nhập ngày"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[16, 16]}>
              <Col span={8}>
                <Form.Item name="note" label="Ghi chú">
                  <Input.TextArea rows={2} placeholder="Nhập ghi chú" />
                </Form.Item>
              </Col>
            </Row>

            <TimeFormList
              form={form}
              name="sim_variant"
              // initialValues={props.initialValues}
              fieldPrefix="sim_variant"
            />

            <Row>
              <Col span={22}>
                <div
                  style={{ borderBottom: "1px solid #ccc", margin: "12px 0" }}
                />
              </Col>
              <Col span={2} />
            </Row>
            <div style={{ margin: "12px 0" }} />

            <Form.Item>
              <Button
                type="primary"
                className="btn-hover-shadow"
                htmlType="submit"
                style={{ minWidth: "76px" }}
              >
                {loading ? <LoadingOutlined /> : "Lưu lại"}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>

      <ListPrice />
    </div>
  )
}

export default SimPriceConfig
